import { organizationDetailQuery } from '../../../data/queries.ts';
import ensureQueriesData from '../../../utils/ensureQueriesData.ts';

export const filesTabLoader = () =>
    ensureQueriesData({
        // organization: organizationDetailQuery(),
    });
